import React, { useEffect } from 'react'
import AddMashup from '../components/AddMashup/AddMashup'

function Unreleased(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
      <h1>{props.title}</h1>
      
      <p className="blurb">Enjoy these clips of mashups I either haven't released or never finished!</p>
      
      <div id="unreleased">
        <AddMashup title="4Minute x NCT 127 - Hate x Cherry Bomb Mashup" type="unreleased"/>
        <AddMashup title="9MUSES A x SF9 - Lip 2 Lip x Good Guy Mashup" type="unreleased"/>
        <AddMashup title="Aespa x BoA - Next Level x Better Mashup" type="unreleased"/>
        <AddMashup title="AoA x Dal Shabet x Girl's Day - Miniskirt x Joker x Something Mashup" type="unreleased"/>
        <AddMashup title="Apink x Nuest x WJSN - Dumhdurum x Inside Out x Unnatural Mashup" type="unreleased"/>
        <AddMashup title="Ariana Grande x EXID - Greedy x Lady Mashup" type="unreleased"/>
        <AddMashup title="Big Bang x Ladies Code - Fantastic Baby x Kiss Kiss Mashup" type="unreleased"/>
        <AddMashup title="Britney Spears x Donna Summer - Criminal x Hot Stuff Mashup" type="unreleased"/>
        <AddMashup title="Britney Spears x Kara - Baby One More Time x Break It Mashup" type="unreleased"/>
        <AddMashup title="Britney Spears x Paper Mario The Origami King - Criminal x Thrills at Night Mashup" type="unreleased"/>
        <AddMashup title="Bruno Mars x Micheal Jackson - Treasure x Scream Feat. Janet Jackson Mashup" type="unreleased"/>
        <AddMashup title="BTS x Shinee - Boy with Love x Good Evening Mashup" type="unreleased"/>
        <AddMashup title="EXID x ITZY x Momoland - Are You Hungry x ICY x Baam x Bboom Bboom x I'm So Hot x Thumbs Up Mashup" type="unreleased"/>
        <AddMashup title="f(x) x Red Velvet x Super Junior - Rum Pum Pum Pum x Hit That Drum x Bonamana Mashup" type="unreleased"/>
        <AddMashup title="Fei x Gfriend - Fantasy x Apple Mashup" type="unreleased"/>
        <AddMashup title="Five x K-Pop - When The Lights Go Out x Shadow Mashup" type="unreleased"/>
        <AddMashup title="Girl's Day x Lou Bega - Darling x Mambo No. 5 Mashup" type="unreleased"/>
        <AddMashup title="Girls' Generation x GOT7 - All Night x Lullaby Mashup" type="unreleased"/>
        <AddMashup title="Girls' Generation x Loona - Gee x Hi High Mashup" type="unreleased"/>
        <AddMashup title="god x EXO-SC - Saturday Night x 1 Billion Views Mashup" type="unreleased"/>
        <AddMashup title="god x EXO-SC - Saturday Night x 1 Billion Views Mashup Alternate" type="unreleased"/>
        <AddMashup title="HOTSHOT x SHINee - I'm a HOTSHOT x Don't Call Me Mashup" type="unreleased"/>
        <AddMashup title="Nature x Sunny Hill - Limbo x The Grasshopper Song Mashup" type="unreleased"/>
        <AddMashup title="NCT 127 x SuperM x Taemin - Superhuman x 100 x Want Mashup" type="unreleased"/>
        <AddMashup title="NCT Dream x Red Velvet - Ridin' x Ice Cream Cake Mashup" type="unreleased"/>
        <AddMashup title="Pentagon x B1A4 - Do or Not x O.K Mashup" type="unreleased"/>
        <AddMashup title="Red Velvet - Jumpin' x Rookie Mashup" type="unreleased"/>
        <AddMashup title="Red Velvet x Sonamoo - Birthday x Cushion Mashup" type="unreleased"/>
        <AddMashup title="Shinee x Wanna One - Good Evening x Energetic Mashup" type="unreleased"/>
        <AddMashup title="Super M x will.i.am - Jopping x Scream &amp; Shout (with Britney Spears) Mashup" type="unreleased"/>
        <div class="bottom-space"><br /></div>
      </div>
    </main>
  )
}

export default Unreleased